import { useMemo } from 'react';
import useFlags from 'components/modules/implementation/Fsp/Detail/common/hooks/useFeatureFlags';

/**
 * Custom hook to check if PAL Guest Payment feature is enabled
 * @returns {boolean} True if 'ontrac-pal-guest-payment' feature flag is ON
 */
export default function usePalGuestPaymentEnabled() {
  const { data, loading: flagLoading } = useFlags('ontrac-pal-guest-payment');

  return useMemo(
    () =>
      !flagLoading &&
      data !== null &&
      data.FlagValue !== null &&
      data.FlagValue,
    [flagLoading, data]
  );
}
